/*
PLEASE USE THE SAMPLE BANNER BLOCK PROVIDED BELOW:

{
    collection: [],
    queries: [],
    link: '',
    bannerImage: '',
    bannerPosition: 1
},

*/

document.addEventListener('Searchanise.Loaded', function () {
    (function ($) {
        function snizeAddCollectionBanner(snizeColUrl, snizeBannerUrl, snizeBannerPosition, snizeCurrentUrl, snizeCurrentQuery) {
            if (location.pathname.includes('/pages/search-results-page') && snizeCurrentQuery.length) {
                let urlParams = new URLSearchParams(window.location.search);
                let paramsQuery = urlParams.get('q');
                for (let query of snizeCurrentQuery) {
                    if (paramsQuery == query) {
                        $(`ul.snize-search-results-content li:nth-child(${snizeBannerPosition})`).before(`
                            <li class="snize-banner snize-custom-banner"><a href=${snizeColUrl} target="_blank"><img src=${snizeBannerUrl}></a></li>`
                        );
                        break;
                    }
                }
            } else if (!location.pathname.includes('/pages/search-results-page') && snizeCurrentUrl.length) {
                for (let url of snizeCurrentUrl) {
                    if ($(location).attr('href').includes(url)) {
                        $(`ul.snize-search-results-content li:nth-child(${snizeBannerPosition})`).before(`
                            <li class="snize-banner snize-custom-banner"><a href=${snizeColUrl} target="_blank"><img src=${snizeBannerUrl}></a></li>`
                        );
                        break;
                    }
                }
            }
        }

        let snizeBannersData = [
            {
                //collection where banner is using  
                collection: ['/collections/mothers-day-gifting'],
                //search queries for which to display the banner
                queries: ['Home fragrance', 'Fragrance', 'Candle', 'Diffuser'],
                //link for redirect after clicking
                link: 'https://www.theroost.com/collections/home-fragrance',
                //link to the banner image
                bannerImage: 'https://cdn.shopify.com/s/files/1/0805/5947/2922/files/3_2e1e1d99-1a05-49a1-bcda-84ab5b276f8b.png?v=1771405970',
                //banner position
                bannerPosition: 25
            },
            {
                collection: ['/collections/mothers-day-gifting'],
                queries: ['Tableware', 'Plates', 'Bowls'],
                link: 'https://theroost.com/collections/tableware',
                bannerImage: 'https://cdn.shopify.com/s/files/1/0805/5947/2922/files/5_fbdb0ae4-3ae6-4ed1-a1ee-091a27b52872.png?v=1771405970',
                bannerPosition: 48
            },
            {
                collection: ['/collections/mothers-day-gifting'],
                queries: ['Art', 'Prints'],
                link: 'https://theroost.com/collections/art-prints',
                bannerImage: 'https://cdn.shopify.com/s/files/1/0805/5947/2922/files/6_4e46ca33-91c6-4fc4-bd71-76fbbdc3dbec.png?v=1771405970',
                bannerPosition: 65
            },
            {
                collection: ['/collections/mothers-day-gifting'],
                queries: ['Faux Flowers', 'Flowers'],
                link: 'https://theroost.com/collections/ett-hem',
                bannerImage: 'https://cdn.shopify.com/s/files/1/0805/5947/2922/files/4_c3262655-e218-45cb-8c8c-a2bd844dcd42.png?v=1771405970',
                bannerPosition: 88
            },
        ];

        $(document).on('Searchanise.ResultsUpdated', function () {
            if (!$('.snize-custom-banner').length) {
                snizeBannersData.forEach(function (bannerData) {
                    snizeAddCollectionBanner(bannerData.link, bannerData.bannerImage, bannerData.bannerPosition, bannerData.collection, bannerData.queries);
                });
            }
        });
    })(window.Searchanise.$);
});
